(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["squishy-buy"] && !Shopify.designMode) return;
  try {
    /* Comprar: agrega la cantidad elegida de la variante de la tarjeta y lleva directo al pago. */
  document.addEventListener('click', function (e) {
    var b = e.target instanceof Element ? e.target.closest('.sq-buy__now') : null;
    if (!b || b.classList.contains('is-busy')) return;
    var card = b.closest('[data-sq-card]');
    var variant = card && card.dataset.variant;
    if (!variant) return;
    var input = card.querySelector('.sq-qty__in');
    var qty = Math.min(99, Math.max(1, parseInt((input && input.value) || '1', 10) || 1));
    b.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: qty }] })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.status) { b.classList.remove('is-busy'); return; }
      window.location.href = '/checkout';
    }).catch(function () { b.classList.remove('is-busy'); });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["squishy-opt-swatches"] && !Shopify.designMode) return;
  try {
    /* Packs: marca como agotados (tachados) los colores que, junto a lo elegido en las otras piezas, no tienen ninguna combinación con stock. */
  (function () {
    function sync(card) {
      var s = card.querySelector('script[data-sq-variants]');
      if (!s) return;
      var data;
      try { data = JSON.parse(s.textContent); } catch (e) { return; }
      var groups = Array.prototype.slice.call(card.querySelectorAll('[data-sq-opt]'));
      var chosen = [];
      groups.forEach(function (g) {
        var p = g.querySelector('.sq-sw__i[aria-pressed="true"]');
        if (p) chosen.push({ i: Number(p.dataset.opt), v: p.dataset.val });
      });
      groups.forEach(function (g) {
        var first = g.querySelector('.sq-sw__i');
        if (!first) return;
        var gi = Number(first.dataset.opt);
        g.querySelectorAll('.sq-sw__i').forEach(function (b) {
          var need = chosen.filter(function (c) { return c.i !== gi; }).concat([{ i: gi, v: b.dataset.val }]);
          var ok = data.some(function (x) { return x.a && need.every(function (c) { return x.o[c.i] === c.v; }); });
          b.classList.toggle('is-out', !ok);
        });
      });
    }
    /* Foto de la tarjeta según la variante elegida (la misma que muestra la ficha). */
    function swapImage(card) {
      var s = card.querySelector('script[data-sq-vimg]');
      if (!s) return;
      var map;
      try { map = JSON.parse(s.textContent); } catch (e) { return; }
      var url = map[card.dataset.variant];
      if (!url) return;
      card.classList.add('is-picked');
      var img = card.querySelector('.sq-pc__media img');
      if (img && img.getAttribute('src') !== url) {
        img.src = url;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
    }
    function all() {
      var seen = [];
      document.querySelectorAll('[data-sq-opt]').forEach(function (g) {
        var c = g.closest('[data-sq-card]');
        if (c && seen.indexOf(c) === -1) { seen.push(c); sync(c); }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('click', function (e) {
      var b = e.target instanceof Element ? e.target.closest('.sq-sw__i[data-opt]') : null;
      if (!b) return;
      var c = b.closest('[data-sq-card]');
      if (c) setTimeout(function () { sync(c); swapImage(c); }, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["squishy-product-card"] && !Shopify.designMode) return;
  try {
    /* Aviso de poco stock según la variante elegida: al tocar un color se recalcula con las unidades de esa variante. Los textos vienen del tema (atributos data-t* y data-s* del aviso). */
  (function () {
    var C = { 1: 'sq-lowstock--one', 2: 'sq-lowstock--two', 3: 'sq-lowstock--three' };
    document.addEventListener('click', function (e) {
      var sw = e.target instanceof Element ? e.target.closest('.sq-sw__i[data-variant]') : null;
      if (!sw) return;
      var card = sw.closest('[data-sq-card]');
      var box = card && card.querySelector('[data-sq-stock-note]');
      if (!box) return;
      var q = parseInt(sw.getAttribute('data-stock'), 10);
      box.textContent = '';
      if (!isNaN(q) && C[q]) {
        var p = document.createElement('p');
        p.className = 'sq-lowstock ' + C[q];
        var s = document.createElement('strong');
        s.textContent = box.getAttribute('data-t' + q) || '';
        var sp = document.createElement('span');
        sp.textContent = box.getAttribute('data-s' + q) || '';
        p.appendChild(s);
        p.appendChild(sp);
        box.appendChild(p);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
